var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{class:['sider-trigger-a', _vm.collapsed ? 'collapsed' : ''],attrs:{"type":"text"},on:{"click":_vm.handleChange}},[_c('Icon',{attrs:{"type":_vm.icon,"size":_vm.size}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }